import { useSyncExternalStore } from 'react';

import { type AutomationNudgeActionEntry } from '../hooks/useConfluenceAutomationNudgeActions.tsx';

const NO_ACTIONS: AutomationNudgeActionEntry[] = [];

let snapshot: AutomationNudgeActionEntry[] = NO_ACTIONS;
const listeners = new Set<() => void>();

const emit = () => {
	listeners.forEach((listener) => listener());
};

const subscribe = (onStoreChange: () => void) => {
	listeners.add(onStoreChange);
	return () => {
		listeners.delete(onStoreChange);
	};
};

const getSnapshot = (): AutomationNudgeActionEntry[] => snapshot;

export const publishAutomationNudgeActions = (actions: AutomationNudgeActionEntry[]): void => {
	snapshot = actions;
	emit();
};

export const clearAutomationNudgeActions = (): void => {
	snapshot = NO_ACTIONS;
	emit();
};

export const clearAutomationNudgeActionsForTesting = (): void => {
	snapshot = NO_ACTIONS;
	listeners.clear();
};

/** Returns the automation discovery nudge actions published by `<AutomationNudgeActionsLoader />`. */
export const useAutomationNudgeActions = (): AutomationNudgeActionEntry[] =>
	useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
